export type ActionCardMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface ActionCardAction {
  method: ActionCardMethod;
  endpoint: string;
  payloadPaths?: Record<string, string>;
  payload?: Record<string, unknown>;
}

export interface ActionCardBase {
  type: string;
  title?: string;
  button: string;
}

export interface ActionCardSendEmail extends ActionCardBase {
  type: 'send-email';
  recipients: Array<{ name: string; email: string; id?: string }>;
  subject?: string;
  content: string;
}

export interface ActionCardCopyableText extends ActionCardBase {
  type: 'copyable-text';
  content: string;
}

export interface ActionCardSendData extends ActionCardBase {
  type: 'send-data';
  fields?: Array<{ key: string; label: string; value?: string }>;
  content?: string;
}

export type ActionCardData =
  | ActionCardSendEmail
  | ActionCardCopyableText
  | ActionCardSendData;

export interface ActionCardPayload {
  version?: string;
  createdTs: string;
  action: ActionCardAction;
  card: ActionCardData;
}

export function isActionCardSendEmail(
  payload: ActionCardPayload
): payload is ActionCardPayload & { card: ActionCardSendEmail } {
  return payload?.card?.type === 'send-email';
}

export function isActionCardPayload(
  value: unknown
): value is ActionCardPayload {
  return (
    typeof value === 'object' &&
    value !== null &&
    'action' in value &&
    'card' in value &&
    typeof (value as ActionCardPayload).card?.type === 'string'
  );
}

export interface SendEmailActionCardAction {
  method?: string;
  protocol?: string;
  params?: Record<string, string>;
  cts?: number;
  endpoint?: string;
}

export interface SendEmailActionCardCard {
  title?: string;
  content: string;
  button: string;
  subject?: string;
  recipients?: Array<{ name?: string; email: string; id?: string }>;
  receipients?: Array<{ name?: string; email: string; id?: string }>;
}

export interface SendEmailActionCardPayload {
  type: 'send-email';
  editable?: boolean;
  action: SendEmailActionCardAction;
  card: SendEmailActionCardCard;
}

export function isSendEmailActionCardPayload(
  value: unknown
): value is SendEmailActionCardPayload {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as SendEmailActionCardPayload).type === 'send-email' &&
    'action' in value &&
    'card' in value
  );
}
